import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OccupancyTranslations } from './occupancy-shorthand.interface';

@Component({
  selector: 'rx-applications-occupancy-shorthand',
  template: ` <ng-container>{{ readableRooms(rooms) }}</ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class OccupancyShorthandComponent {
  @Input() rooms: string = '';
  @Input() translations: OccupancyTranslations;

  readableRooms(rooms: string): string {
    if (!rooms || !this.#isValidRoomString(rooms)) {
      return '';
    }

    const roomValues = rooms.split(',').map(Number);
    const total = roomValues.reduce((prev, current) => prev + current, 0);
    const count = roomValues.filter((v) => v > 0).length;

    const roomLabel = count > 1 ? this.translations.rooms : this.translations.room;
    const adultLabel = total > 1 ? this.translations.adults : this.translations.adult;

    return `${count} ${roomLabel}, ${total} ${adultLabel}`;
  }

  #isValidRoomString = (str: string): str is string => {
    const parts = str.split(',');
    return parts.length === 8 && parts.every((part) => !isNaN(Number(part))); // 8 rooms in the string, each part represents 1 room, e.g "1,0,0,0,0,0,0,0"
  };
}
